//dependencies
import React from "react";

//components
import FilterChips from "../../../../../../../components/FilterChips";
import { Filter } from "../../../../../../../components/FilterChips/FilterChips";

import {
	ReviewsOfMyTeam360ReviewsOptions,
	ReviewsOfMyTeamFilters,
	ReviewsOfMyTeamStatusOptions,
} from "../ReviewsOfMyTeamFilterPanel";

const convertFiltersToReadableList = (filters?: ReviewsOfMyTeamFilters) => {
	const readableList: Filter[] = [];

	Object.keys(filters || {}).forEach((filterKey) => {
		const filter = filters[filterKey];

		if (filterKey === "subject" && filter && typeof filter === "object" && "id" in filter && "name" in filter) {
			readableList.push({
				id: "subject",
				type: "single-employee",
				label: "Subject",
				value: { name: filter.name, id: filter.id },
			});
		}

		if (filterKey === "easyAddStatus") {
			readableList.push({
				id: "easyAddStatus",
				type: "string",
				label: "360 Status",
				value: ReviewsOfMyTeam360ReviewsOptions.find((option) => option.value === filter)?.label,
			});
		}

		// Only show status chip if it's not "any"
		if (filterKey === "status" && filter && filter !== "any") {
			const statusLabel = ReviewsOfMyTeamStatusOptions.find((option) => option.value === filter)?.label;
			if (statusLabel) {
				readableList.push({
					id: "status",
					type: "string",
					label: "Status",
					value: statusLabel,
				});
			}
		}
	});
	return readableList;
};

type ReviewsOfMyTeamReadableFiltersListProps = {
	filters: ReviewsOfMyTeamFilters;
	setFilters: (newFilters) => void;
};
const disabledFilters = [{ id: "status", value: "Any", label: "Status", type: "string" as const }];

const ReviewsOfMyTeamReadableFilters = ({ filters, setFilters }: ReviewsOfMyTeamReadableFiltersListProps) => {
	const statusValue = filters?.status || "any";
	const hasOtherFilters = filters?.subject || filters?.easyAddStatus;

	// Hide filters bar if status is "any" and there are no other filters
	if (statusValue === "any" && !hasOtherFilters) {
		return null;
	}

	const convertedFilters = convertFiltersToReadableList(filters);
	if (convertedFilters.length === 0) {
		return null;
	}

	return (
		<FilterChips
			filters={convertedFilters}
			label="Filters applied: "
			disabledFilters={disabledFilters}
			onDeleteFilter={(id) => {
				const newFilters = { ...filters };
				delete newFilters[id];
				// Remove undefined values to clean up the object
				Object.keys(newFilters).forEach((key) => {
					if (newFilters[key] === undefined) {
						delete newFilters[key];
					}
				});
				setFilters(newFilters);
			}}
		/>
	);
};

export default ReviewsOfMyTeamReadableFilters;
